import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/* TODO:
- implement tests for custom element
- implement it on readme
*/

const Icon = ({ className, element, variant, ...props }) => {
  const noVariantStyle = !variant ? { color: '#FC3411' } : {};
  const Element = element;

  return (
    <Element
      className={classnames(
        'nyc-icon',
        `nyc-icon-${variant || 'toast-warning'}`,
        className
      )}
      style={noVariantStyle}
      {...props}
    />
  );
};

Icon.defaultProps = {
  element: 'i'
};

Icon.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string.isRequired,
  element: PropTypes.string
};

export default Icon;
